import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "components/Common/Breadcrumb2";
import { fetchAttendanceRequest } from "store/attendance/actions";
import { fetchCoursesRequest } from "store/actions";
import AttendanceTable from "./AttendanceTable";

const AttendanceList = () => {
  const dispatch = useDispatch();
  const attendance = useSelector((state) => state.Attendance.attendance);
  const courses = useSelector((state) => state.Course.courses);
  const loading = useSelector((state) => state.Attendance.loading);

  // ✅ Pagination & filter states
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedSortData, setSelectedSortData] = useState({
    value: "studentName",
    direction: "asc",
  });

  // ✅ Fetch courses initially
  useEffect(() => {
    dispatch(fetchCoursesRequest());
  }, [dispatch]);

  // ✅ Fetch attendance data when filters/pagination change
  useEffect(() => {
    const params = {
      page: pageIndex,
      limit: pageSize,
    };
    if (searchString) params.search = searchString;
    if (selectedCourse) params.courseId = selectedCourse.value;
    if (selectedSortData?.value && selectedSortData?.direction)
      params.sortBy = `${selectedSortData.value}:${selectedSortData.direction}`;

    dispatch(fetchAttendanceRequest(params));
  }, [pageIndex, pageSize, searchString, selectedCourse, selectedSortData, dispatch]);

 
  const courseOptions =
    courses?.data?.map((course) => ({
      value: course._id,
      label: course.title,
    })) || [];

  return (
    <div className="page-content container-fluid">
      <div className="d-flex justify-content-between align-items-center mx-3">
        <Breadcrumb
          title="Attendance"
          breadcrumbItems={[
            { title: "Dashboard", link: "/dashboard" },
            { title: "Attendance", link: "#" },
          ]}
        />
      </div>

      <AttendanceTable
        data={attendance?.data || []}
        totalrows={attendance?.total || 0}
        loading={loading}
        courseOptions={courseOptions}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        searchString={searchString}
        setSearchString={setSearchString}
        selectedCourse={selectedCourse}
        setSelectedCourse={setSelectedCourse}
        selectedSortData={selectedSortData}
        setSelectedSortData={setSelectedSortData}
      />
    </div>
  );
};

export default AttendanceList;
